import React, { useEffect } from "react";
import styles from "./HamperProduct.module.css";
import myStyles from "../../Products/SpecificProduct/SpecificProduct.module.css";
import useHamperStore from "../../../Stores/useHamperStore";
import { handleImgError } from "../../Shared/ImageError";
import { json } from "react-router-dom";

function HamperProduct({ productId, evaluateSelection = false }) {
  const { selectedHamper, updateProductSelection, getProductSelection } =
    useHamperStore();
  const [prod, setProd] = React.useState(null);

  useEffect(() => {
    if (selectedHamper?.Products) {
      const product = selectedHamper.Products.find(
        (p) => p.Product.Id === productId,
      );
      setProd(product.Product);
    }
  }, [selectedHamper, productId]);


  const needsSelecting = (prodId, optionId) => {
    if (evaluateSelection) {
      // Logic to evaluate selection
      let selection = getProductSelection(prodId, optionId);
      if (!selection) {
        return true;
      }
    }
    return false;
  };

  return prod ? (
    <div className={styles.HamperProduct}>
      <img
        src={prod.Images && prod.Images.length > 0 ? prod.Images[0].src : ""}
        alt={
          prod.Images && prod.Images.length > 0 ? prod.Images[0].alt : prod.Name
        }
        className={styles.ProductImage}
        onError={handleImgError}
      />
      <div className={styles.ProductName}>{prod.Name}</div>
      <div className={styles.Options}>
        {prod.Options && prod.Options.length > 0
          ? prod.Options.map((option) => (
              <select
                key={option.Id}
                onChange={(e) =>
                  updateProductSelection(prod.Id, option.Id, e.target.value)
                }
                value={getProductSelection(prod.Id, option.Id)}
                className={`${styles.OptionSelect} ${needsSelecting(prod.Id, option.Id) ? styles.NeedsSelecting : ""}`}
              >
                <option value="">{option.OptionName}</option>
                {option.OptionValues.map((value) => (
                  <option
                    key={value.Id}
                    value={value.Id}
                    className={styles.Option}
                  >
                    {value.Value}
                  </option>
                ))}
              </select>
            ))
          : null}
      </div>
    </div>
  ) : null;
}

export default HamperProduct;
